/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { theme } from "@nordcloud/gnui";
import { DetailCopyClipboard } from "./DetailCopyClipboard";
import {
  DetailsDescription,
  DetailsItem,
  DetailWrapper,
  ValueWrapper,
} from "./styles";
import { isString } from "./utils";

export type DetailData = {
  label?: string;
  value: string | string[] | number | undefined | null;
  clipboard?: boolean;
  link?: string;
};

type Props = {
  detail: DetailData;
};

export function Detail({ detail }: Props) {
  const clipboardValue = isString(detail.value) ? detail.value : "";
  const isEmpty = detail.value == null;

  return (
    <DetailsItem>
      <DetailWrapper
        aria-label="details item"
        columnGap={theme.spacing.spacing02}
        style={{
          maxWidth: "100%",
        }}
      >
        <div
          style={{
            direction: "rtl",
            overflow: "hidden",
          }}
        >
          <DetailsDescription>
            <ValueWrapper isEmpty={isEmpty} editable={false}>
              {detail.link ? (
                <a
                  style={{
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                  href={detail.link}
                  rel="noopener noreferrer"
                >
                  {detail.value}
                </a>
              ) : (
                detail.value ?? "No data provided"
              )}
            </ValueWrapper>
          </DetailsDescription>
        </div>

        {detail.clipboard && !isEmpty && (
          <DetailCopyClipboard value={clipboardValue} />
        )}
      </DetailWrapper>
    </DetailsItem>
  );
}
